import React from 'react';

import { sendRequest, triggerEvent } from '../../helpers/global.js';

import '../../sass/components/common/ContactBlock.scss';

export default class ContactBlock extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  onContact = () => {
    if (this.props.onContact) {
      this.props.onContact();
    }
    sendRequest({
      method: 'me/request_consultation',
      type: 'POST',
      success: (data) => {
        triggerEvent('showSnackbar', [{text: 'Success! We’ll get in touch with you soon.'}]);
      },
      error: (data) => {
      }
    });
  }

  render = () => {
    return (
      <div
        className='contactBlock'
        ref={this.props.elemRef}
      >
        <div className='contactImage'/>
        <div className='contactTitle'>Looking to reach more people?</div>
        <div className='contactDescription'>
          We’re here to help. Book a consultation with Burpple to identify 
          actionable insights on how to grow your business with the Burpple platform.
        </div>
        <button onClick={this.onContact}>Contact us</button>
      </div>
    )
  }

}
